<a class="item" [routerLink]="[notification.contentId]" routerLinkActive="router-link-active"
        [class.item--read]="notification.status === NotificationStatus.Read">
    <div class="item__text" [innerHTML]="notification.publishedDate | haDate:'dateTimeLongMonthWithYear'"></div>
    <div class="item__heading" [innerHTML]="notification.heading"></div>
    <div class="item__text" [innerHTML]="notification.mainBody"></div>
</a>
